module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-copy-5-c4a61d1bcca25f51d27bb61033919fd5.svg";